module.exports = __webpack_public_path__ + "static/img/arrow-up.6659eec2.svg";